(function ($, window, document) {

  function onDOMContentLoaded() {
    var $container = $('.js-cms-content');
    // Add Bootstrap table class for all tables within CMS content
    // and make tables scrollable on small viewports
    $container.find('table')
      .addClass('table')
      .wrap($('<div />').css({ 'overflow-x': 'scroll' }));
  }
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }

})(jQuery, window, document);
